import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 123,
    sideNav: [],
    roleInfo: {
      nav: {},
      num: 0,
      topNav: {}
    },
    permissionTree: [],
    // 激活状态的路由列表
    activeTabsList: [],
    // 所在页面的路由
    activeTab: '',
    menuTree: [],
    entityTree: [],
    userInfo: {},
    // 组织管理树
    orgainzationTree: [],
    // 页面模块维护树
    pageComTree: [],
    // 数据管理树
    pageIndicatorTree: [],
    // 页面实例树
    pageInstanceTree: []
  },
  getters: {
    countNum: state => {
      return state.count
    },
    topNavList: state => {
      return state.roleInfo
    },
    getActiveTabList: (state) => {
      return state.activeTabsList
    }
  },
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js